import { type FC, type ReactNode, type Ref } from "react";

// A section with its assistant open: the toolbar row over the two panes,
// filling the height it's given (see useFillHeight).
export const AssistantSplit: FC<{
  fillRef?: Ref<HTMLDivElement>;
  height?: number;
  toolbar: ReactNode;
  children: ReactNode;
}> = ({ fillRef, height, toolbar, children }) => (
  <div
    ref={fillRef}
    style={{ height }}
    className="flex min-h-[480px] min-w-0 flex-col"
  >
    {toolbar}
    <div className="flex min-h-0 flex-1 gap-4 pt-3">{children}</div>
  </div>
);

// A plain right half (the upload or processing card), scrolling on its own.
export const AssistantSplitSide: FC<{ children: ReactNode }> = ({
  children,
}) => <div className="min-h-0 min-w-0 flex-1 overflow-y-auto">{children}</div>;
